import "./WhatsAppButton.css";

const WHATSAPP_NUMBER = "34646273415";

const WHATSAPP_MESSAGE =
  " ¿Te ayudamos?";

export default function WhatsAppButton() {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE
  )}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      WhatsApp
    </a>
  );
}